import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CartAPI from '@/utils/cartApi';
import { incrementCount } from '@/store/reducers/cart';
import { Multiselect, Label } from '@/components/Form/FormStyler';
import { NormalButton } from '@/components/Buttons/Button';
import {
  gaCreateEvent,
  gaGetECommerce,
  gaGetTotalValue
} from '@/utils/gaUtils';

const BasketIcon = styled(FontAwesomeIcon)`
  padding: 0;
  margin: 0 0.7em 0 0;
  width: auto;
  position: relative;
  transform: scale(1.35);
  top: -2px;
`;

const Button = styled(NormalButton)`
  text-transform: uppercase;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
`;

const Select = styled(Multiselect)`
  margin-bottom: 22px;
  width: 150px;
`;

class AddToCart extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    buttonstyle: PropTypes.string,
    displayQuantity: PropTypes.bool,
    onCartAdded: PropTypes.func
  };
  static defaultProps = {
    displayQuantity: false
  };

  state = {
    loading: false,
    quantity: 1
  };

  async handleAddToCart(product) {
    this.setState({ loading: true });

    try {
      const apiCall = await CartAPI.addToCart(product.id, this.state.quantity);
      const apiCallJSON = JSON.parse(apiCall);
      if (apiCallJSON.key) {
        const gaOptions = {
          event: 'add_to_cart',
          ecommerce: gaGetECommerce({
            currency: 'EUR',
            value: gaGetTotalValue([product]),
            items: [product]
          })
        };
        gaCreateEvent(gaOptions, true);

        // Callback for updating the parent component if needed
        if (this.props.onCartAdded) {
          this.props.onCartAdded();
        }
      }
      this.props.incrementCount();
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading } = this.state;
    const { product, buttonstyle, size } = this.props;

    if (!product.purchasable) {
      return false;
    }

    // TODO Add variants selections
    const values = [1, 2, 3, 4, 5];
    const options = values.map((value) => ({ value: value, label: value }));
    const displayQuantity =
      this.props.displayQuantity && !product.sold_individually;
    return (
      <div>
        {displayQuantity && !product.virtual && (
          <div>
            <Label>Lukumäärä</Label>
            <Select
              options={options}
              multi={false}
              placeholder="Valitse..."
              onChange={(opt) => this.setState({ quantity: opt.value })}
            />
          </div>
        )}
        <Button
          onClick={() => this.handleAddToCart(product)}
          disabled={loading}
          $buttonstyle={buttonstyle}
        >
          <BasketIcon icon={['fal', 'shopping-basket']} />
          <FormattedMessage
            id={loading ? 'label.loading' : 'action.addToCart'}
          />
        </Button>
      </div>
    );
  }
}

export default connect(null, { incrementCount })(AddToCart);
